import React, { useEffect, useState } from 'react';
import { Modal, Table, TableColumn } from 'tea-component';
import { autotip, scrollable } from 'tea-component/lib/table/addons';
import { useRequest } from 'ahooks';
// import {getTablePreviewData} from '../service';
import { getLocalText, useDblIntl } from "@/pages/datalab/utils/utils";
import type { ITableColumnDto } from '@dbl/services/dataSource';
import { FieldType } from '@dbl/core/dataSource';
import {
  DimensionType,
  DimensionValue,
  Include255,
} from '@dbl/core/dataSource';
import { getTableInfoList } from '@dbl/services/dataSource';
import './DataTableDetail.scss';

export default function DataTableDetail(props: {
  showTableDetail: boolean;
  setShowTableDetail: Function;
  tableDetailId: string;
  tableName: string;
  gameCode: string;
}) {
  const { showTableDetail, setShowTableDetail, tableDetailId, tableName, gameCode } = props;
  const { dblFormatMessage: dataFormatMessage, commonFormatMessage, isEn } = useDblIntl("data_table");
  // const options = [
  //   {text: dataFormatMessage("structure"), value: '1'},
  //   {text: dataFormatMessage("data_preview"), value: '2'},
  // ];
  const [curOptionValue, setCurOptionValue] = useState<string>('1');

  const [records, setRecords] = useState([]);
  const [columns, setColumns] = useState<any[]>([]);

  const [tableStructRecords, setTableStructRecords] = useState([]);

  const [tablePreviewDataRecords, setTablePreviewDataRecords] = useState([]);
  const [tablePreviewDataColumns, setTablePreviewDataColumns] = useState<any[]>([]);

  const {
    loading: runGetTableStructLoading,
    error: runGetTableStructError,
    runAsync: runGetTableStruct,
  } = useRequest(getTableInfoList, {
    manual: true,
  });

  // const {
  //   loading: runGetTablePreviewDataLoading,
  //   error: runGetTablePreviewDataError,
  //   runAsync: runGetTablePreviewData,
  // } = useRequest(getTablePreviewData, {
  //   manual: true,
  // });

  useEffect(() => {
    if (showTableDetail) {
      setCurOptionValue('1');
      setTableStructRecords([]);
      setTablePreviewDataRecords([]);
      setTablePreviewDataColumns([]);
      runGetTableStruct([tableDetailId], gameCode).then((res) => {
        setTableStructRecords(res?.[0]?.column_list || []);
      });
      // runGetTablePreviewData({table_id: tableDetailId}).then((res) => {
      //   setTablePreviewDataColumns(buildPreviewDataColumns(res?.columns) || []);
      //   setTablePreviewDataRecords(res?.data_list || []);
      // });
    }
  }, [showTableDetail]);

  useEffect(() => {
    switch (curOptionValue) {
      case '1':
        setRecords(tableStructRecords);
        setColumns(structColumns);
        break;
      case '2':
        setRecords(tablePreviewDataRecords);
        setColumns(tablePreviewDataColumns);
        break;
    }
  }, [curOptionValue, tableStructRecords, tablePreviewDataRecords]);

  const structColumns: TableColumn[] = [
    {
      key: 'display_name',
      header: dataFormatMessage('display_name'), // 显示名称
      width: 185,
      render(record: ITableColumnDto) {
        return (<div>{(isEn ? record.display_name_en : record.display_name) || record.display_name || record.name || '-'}</div>);
      }
    },
    {
      key: 'name',
      header: dataFormatMessage('field_name'), // 字段名称
      width: 185,
      render(record: ITableColumnDto) {
        return (<div>{record.name || '-'}</div>);
      }
    },
    {
      key: 'type',
      header: dataFormatMessage('field_type'), // 字段类型
      width: 120,
      render(record: ITableColumnDto) {
        return Object.values(FieldType).includes(record.type) ? dataFormatMessage(record.type) : '-';
      }
    },
    {
      key: 'attribute',
      header: (isEn ? <div>
        <span>Dimension/</span>
        <br />
        <span>Metric</span>
      </div> : <div>{dataFormatMessage('metric_dimension')}</div>), // 维度/指标
      // width: isEn ? 180 : 140,
      width: 130,
      render(record: ITableColumnDto) {
        return record.is_metric ? dataFormatMessage('metric') : dataFormatMessage('dimension'); // is_metric不会变化, 可以作为原始值 和 新值进行判断
      }
    },
    {
      key: 'dimension_setting',
      header: (<div>{dataFormatMessage('dimension_value_settings')}</div>), // 维度值设置
      width: 140,
      render(record: ITableColumnDto) {
        if (record.attribute === DimensionType.Metric) {
          return '-';
        }
        return record.dimension_setting === DimensionValue.Origin ? dataFormatMessage('origin') : dataFormatMessage('system');
      }
    },
    {
      key: 'flag',
      header: (<div>{dataFormatMessage('include_dimension_total_value')}</div>), // 是否含维度汇总
      width: 160,
      render(record: ITableColumnDto) {

        if (record.attribute === DimensionType.Metric) {
          return '-';
        }
        return record.flag === Include255.Include ? dataFormatMessage('include') : dataFormatMessage('exclude');
      }
    },
    {
      key: 'remark',
      header: dataFormatMessage('field_desc'), // 字段说明
      width: 240,
      render(record: ITableColumnDto) {
        return (<div>{getLocalText(isEn, record.remark, record.remark_en) || '-'}</div>);
      }
    },
  ];


  return (
    <Modal
      visible={showTableDetail}
      caption={<span style={{ fontSize: 16, fontWeight: 'bold' }}>{tableName}</span>}
      size="80%"
      onClose={() => {
        setShowTableDetail(false);
      }}
      className={'dbl-add-source-detail-modal dbl-sql-view-detail'}
    >
      <Modal.Body style={{height: 'calc(100% - 52px)'}}>
        <Table
          columns={columns}
          records={records}
          addons={[
            scrollable({
              maxHeight: 'calc(100% - 74px)',
              minWidth: 1000,
              scrollToTopOnChange: true,
            }),
            autotip({
              // isLoading: curOptionValue === '1' ? runGetTableStructLoading : runGetTablePreviewDataLoading,
              // isError: curOptionValue === '1' ? !!runGetTableStructError : !!runGetTablePreviewDataError,
              isLoading: runGetTableStructLoading,
              isError: !!runGetTableStructError,
              style: { lineHeight: '200px' },
              emptyText: commonFormatMessage("no_data"),
              loadingText: commonFormatMessage("loading"),
              errorText: commonFormatMessage("load_fail"),
              clearResultText: commonFormatMessage("go_back_old"),
            }),
          ]}
        />
      </Modal.Body>
    </Modal>
  );
}
